import cx from 'classnames';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

export interface CheckboxProps extends ComponentPropsWithoutRef<'div'> {
  inputProps: Omit<ComponentPropsWithoutRef<'input'>, 'id' | 'name'>;
  id: string;
  label: ReactNode;
  labelClassName?: string;
}

export default function Checkbox({
  className,
  id,
  label,
  inputProps,
  labelClassName,
  ...spreadProps
}: CheckboxProps) {
  return (
    <div
      className={cx('font-size-sm custom-control custom-checkbox', className)}
      {...spreadProps}
    >
      <input
        {...inputProps}
        className={'custom-control-input cursor-pointer'}
        type="checkbox"
        id={id}
        name={id}
      />
      <label
        className={cx('custom-control-label cursor-pointer', labelClassName)}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}
